import React from "react";

import { Button, Modal, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function PendingRegistrationModal({
  email,
  visible,
  sending,
  onSend,
  onCancel,
}) {
  return (
    <Modal
      className="pendingRegistrationModal"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      width={420}
      maskClosable={!sending}
      closable={!sending}
      destroyOnClose
    >
      <div className="pendingRegistrationIcon">
        <MailOutlined />
      </div>
      <Title level={3} className="pendingRegistrationTitle">
        You already have an account
      </Title>
      <span className="pendingRegistrationEmail">{email}</span>
      <Text className="pendingRegistrationText">
        An account with this name and email is already on file. We can email you a link to set up your password. Your booking details will be kept.
      </Text>
      <Button
        type="primary"
        block
        loading={sending}
        onClick={onSend}
        className="pendingRegistrationSend"
      >
        Send welcome email
      </Button>
      <Button
        type="text"
        disabled={sending}
        onClick={onCancel}
        className="pendingRegistrationCancel"
      >
        Not now
      </Button>
    </Modal>
  );
}
